function roundHalfUpExp(amount: number, exp: number): number {
  return Number(`${Math.round(Number(`${amount}e${exp}`))}e-${exp}`)
}

export function roundGross(amount: number, currency: string): number {
  if (!Number.isFinite(amount)) return 0
  if ((currency || '').toUpperCase() === 'CHF') {
    return roundHalfUpExp(amount / 0.05, 0) * 0.05
  }
  return roundHalfUpExp(amount, 2)
}

export function applyDeal(listUnit: number, dealPercent: number, currency: string): number {
  const deal = Math.min(100, Math.max(0, Number.isFinite(dealPercent) ? dealPercent : 0))
  return roundGross(listUnit * (1 - deal / 100), currency)
}

export function formatMoney(amount: number, currency?: string | null): string {
  const n = Number.isFinite(amount) ? amount : 0
  const ccy = (currency || '').toUpperCase()
  const digits = ccy === 'CHF' ? 2 : 2
  const formatted = n.toFixed(digits)
  return ccy ? `${formatted} ${ccy}` : formatted
}

export function asNumber(value: number | string | null | undefined): number {
  const n = typeof value === 'number' ? value : Number(value)
  return Number.isFinite(n) ? n : 0
}
